import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Label } from 'reactstrap';
import SearchableSelect from '../fields/SearchableSelect';
import * as Validators from '../../util/Validators';
import {
  isImportAndContainer,
  isExportAndContainer,
  isImportJobType,
  isExportAndLogs,
} from '../../util/JobTypeHelper';
import {
  fumigantWarehouseLocation,
  mbDescription,
  alpDescription,
  cssDescription,
  efDescription,
  hcnDescription,
  macslayDescription,
  pestiDescription,
  thermoFogDescription,
  vapormateDescription,
  vaporphosDescription,
  sfDescription,
} from '../../constants/ListConstants';

import RenderField from './RenderField';
import CheckboxField from './CheckboxField';

import ToggleButton from '../layout/ToggleButton';

import styles from './MarkingsFieldArray.module.scss';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { getMacUsage } from '../../util/TreatmentTypeCalcuationsHelper';

const propTypes = {
  // label: PropTypes.string,
  // fields: PropTypes.object.isRequired,
  // meta: PropTypes.object.isRequired,
};
var selector = formValueSelector('treatmentResultRecordsForm');
var selector2 = formValueSelector('treatmentResultsForm');

const mapStateToProps = (state) => {
  var markings = selector(state, 'fumigantDetails');
  if (markings == undefined) {
    markings = selector2(state, 'fumigantDetails');
  }
  return { markings };
};

function FumigantDetailFieldArray({
  fields,
  meta: { error },
  label,
  markings,
}) {
  const currentJob = useSelector((state) => state.currentJob);
  const getCurrentState = currentJob.currentState;
  // const getTreatmentType = currentJob.treatmentDetails.treatmentTypeId;
  const addNewMarking = (e) => {
    if (e.which === 13 || e.keyCode === 13) {
      e.preventDefault();
      fields.push({});
      //fields.push(mac)
    }
  };
  //fields.push(mac[0])
  var fumigantList = mbDescription;
  var usage = '0';
  var treatmentType;
  var treatmentTypeId = currentJob.treatmentDetails.treatmentTypeId;
  if (
    treatmentTypeId == 'b5532f99-23b8-185d-7521-c5864d240159' ||
    treatmentTypeId == 'b3c32f99-a3b8-465d-5568-c5864d240b66' ||
    treatmentTypeId == 'fa3a2d70-b743-4f98-867b-9e152a364233'
  ) {
    fumigantList = alpDescription;
    treatmentType = 'alp';
  }
  if (treatmentTypeId == 'a2a32f99-b3b6-455c-8598-a5864d240a56') {
    fumigantList = vaporphosDescription;
    treatmentType = 'vaporphos';
  }
  if (treatmentTypeId == '2e5ab48c-48c9-49e7-9ba6-3b7a438b550a') {
    fumigantList = cssDescription;
    treatmentType = 'css';
  }
  if (treatmentTypeId == '95faca5e-cc67-4824-8cf2-6938dec46157') {
    fumigantList = efDescription;
    treatmentType = 'ef';
  }
  if (treatmentTypeId == 'fd587c29-5a6b-4932-a7d8-ca1bc14af155') {
    fumigantList = hcnDescription;
    treatmentType = 'hcn';
  }
  if (treatmentTypeId == '0b189349-8457-480f-85b9-75cb42cf0d94') {
    fumigantList = macslayDescription;
    treatmentType = 'mac';
    usage = getMacUsage(currentJob);
  }
  if (treatmentTypeId == '0f3395bf-1052-4d4d-a803-f975be39b5ce') {
    fumigantList = pestiDescription;
    treatmentType = 'pesti';
  }
  if (treatmentTypeId == '655117ab-5a89-4a77-8a82-68416c6a72b0') {
    fumigantList = thermoFogDescription;
    treatmentType = 'thermofog';
  }
  if (treatmentTypeId == 'd2d32f97-d3b6-455a-8597-c5864d140f45') {
    fumigantList = vapormateDescription;
    treatmentType = 'vapormate';
  }
  if (treatmentTypeId == '856117af-5a89-4a77-8a82-70416c6b72c9') {
    fumigantList = sfDescription;
    treatmentType = 'sf';
  }
  //fields.push(mac[0])

  return (
    <div className={styles.fumMarkingsFieldArray}>
      {label && <Label className={styles.fumLabel}>{label}</Label>}

      {fields.map((fumigantDetailsJson, index) => {
        const eralisUpdated =
          markings != undefined
            ? markings[index].eralisUpdated
              ? true
              : false
            : false;
        return (
          <div key={index} className={styles.fumMarkingItem}>
            <Field
              name={`${fumigantDetailsJson}.description`}
              component={SearchableSelect}
              options={fumigantList}
              valueKey="value"
              labelKey="label"
              placeholder="Description"
              className={styles.wideSelect}
              validate={Validators.mandatoryList}
              disabled={eralisUpdated}
            />
            <Field
              name={`${fumigantDetailsJson}.usage`}
              type="number"
              component={RenderField}
              placeholder={
                treatmentType === 'mac' ? '# Flask/Blanket used' : 'usage'
              }
              onKeyPress={addNewMarking}
              validate={Validators.requiredTrue}
              readOnly={eralisUpdated}
            />
            {eralisUpdated ? (
              <span
                style={{
                  color: 'red',
                  fontSize: '18px',
                  fontWeight: 'bold',
                }}
              >
                Posted
              </span>
            ) : (
              <span
                title="Remove Marking"
                aria-label="Clear value"
                onClick={() => fields.remove(index)}
              >
                <span className={styles.clear}>×</span>
              </span>
            )}
          </div>
        );
      })}
      {getCurrentState === 'in progress' || getCurrentState === 'assigned' ? (
        <ToggleButton
          className={styles.addButton}
          color="light"
          onClick={() =>
            treatmentTypeId === '0b189349-8457-480f-85b9-75cb42cf0d94'
              ? fields.push({
                  description: fumigantList[0].value,
                  usage: usage,
                })
              : fields.push({})
          }
          ligature="add"
        />
      ) : null}
    </div>
  );
}

FumigantDetailFieldArray.propTypes = propTypes;

export default connect(mapStateToProps)(FumigantDetailFieldArray);
